module.exports = __webpack_public_path__ + "img/speakpipe-logo-gray.65b360ad.svg";